const formFields = document.querySelectorAll('input[type="file"]');

function handleFileInputChange(inputElement) {
	const inputField = inputElement.target;
	const classNameToAdd = 'has-value';

	if (inputField.value.trim() !== '') {
		inputField.classList.add(classNameToAdd);
	} else {
		inputField.classList.remove(classNameToAdd);
	}
}

for (let i = 0; i < formFields.length; i++) {
	const field = formFields[i];

	field.addEventListener('change', handleFileInputChange);
}
